import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, FileText, Zap, Star } from 'lucide-react';
import { CTAButton } from './Shared';
const heroImage = {
  src: 'https://cdn.magicpatterns.com/uploads/sEdxQ2BeQFBTUprmWfeqSF/jkkjgjhkj.png',
  alt: 'Kit Reflexo-Pro + Acelerador de Consultorio - Mockup completo'
};
export const Hero = () => {
  return <div className="relative overflow-hidden pt-12 pb-8 md:pt-20 md:pb-12 bg-transparent" data-id="element-124">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-pink/20 rounded-full blur-[140px] -z-10 pointer-events-none" data-id="element-125"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="bg-transparent space-y-[0px]" data-id="element-127">
          <div className="inline-flex items-center justify-center bg-white border border-brand-pink/50 px-4 py-1.5 rounded-full mb-6 gap-2 shadow-sm pt-[2px] pb-[2px] pl-[10px] pr-[10px]" data-id="element-128">
            <span className="text-sm" data-id="element-129">🦶</span>
            <span className="font-serif font-semibold tracking-wider text-xs md:text-sm text-brand-text" data-id="element-130">
              LUMEN AKASHA™
            </span>
          </div>

          <h1 className="sm:text-4xl md:text-6xl lg:text-7xl font-serif font-bold mb-4 max-w-4xl mx-auto text-[20px]" data-id="element-131">
            Documentá la evolución de tus pacientes hoy mismo
          </h1>
          <p className="md:text-2xl text-brand-rose mb-8 font-bold font-[Georgia,_serif] text-[12px]" data-id="element-132">
            planillas listas para usar
          </p>

          {/* Hero Image */}
          <div className="relative z-10 max-w-md md:max-w-2xl mx-auto mb-2" data-id="element-133">
            <div className="relative overflow-hidden rounded-2xl bg-white/40 border border-brand-pink/20 shadow-lg" style={{
            aspectRatio: '1/1',
            maxHeight: '520px'
          }} data-id="element-134">
              <motion.img src={heroImage.src} alt={heroImage.alt} initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.6,
              ease: 'easeOut'
            }} className="absolute inset-0 w-full h-full object-contain p-2 md:p-4 pt-[8px] pb-[8px]" draggable={false} data-id="element-135" />
            </div>
          </div>

          <div className="max-w-3xl mx-auto mb-8 mt-8 space-y-3 px-2" data-id="element-136">
            <p className="md:text-xl font-bold text-brand-rose font-[Georgia,_serif] text-[12px]" data-id="element-137">
              El sistema completo para terapeutas en reflexología que necesitan
              registrar, organizar y hacer seguimiento profesional de sus
              pacientes
            </p>
            <p className="md:text-base text-brand-text/80 font-[Inter,_sans-serif] text-[12px]" data-id="element-138">
              Guía clínica + planillas de registro + control de stock. Todo en
              un solo kit.
            </p>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3 mb-12 text-xs md:text-sm font-medium" data-id="element-139">
            <div className="inline-flex items-center bg-white px-3 py-2 rounded-full border border-brand-pink/30 whitespace-nowrap shadow-sm text-[10px]" data-id="element-140">
              <FileText className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5 text-brand-rose shrink-0" data-id="element-141" />
              100% PDF
            </div>
            <div className="inline-flex items-center bg-white px-3 py-2 rounded-full border border-brand-pink/30 whitespace-nowrap shadow-sm text-[10px]" data-id="element-142">
              <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5 text-brand-rose shrink-0" data-id="element-143" />
              Acceso en 5 min
            </div>
            <div className="inline-flex items-center bg-white px-3 py-2 rounded-full border border-brand-pink/30 whitespace-nowrap shadow-sm text-[10px]" data-id="element-144">
              <span className="mr-1.5 text-brand-rose shrink-0" data-id="element-145">🇦🇷</span>
              Hecho para Argentina
            </div>
            <div className="inline-flex items-center bg-white px-3 py-2 rounded-full border border-brand-pink/30 whitespace-nowrap shadow-sm text-[10px]" data-id="element-146">
              <span className="mr-1.5 text-brand-rose shrink-0" data-id="element-147">🦶</span>
              Todos los niveles
            </div>
          </div>

          <div className="flex flex-col items-center space-y-6" data-id="element-148">
            <CTAButton className="text-base md:text-xl px-6 md:px-10 py-4 md:py-5" data-id="element-149">
              🦶 → QUIERO MI KIT REFLEXO-PRO AHORA
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs md:text-sm text-brand-muted" data-id="element-150">
              <div className="flex items-center" data-id="element-151">
                <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-152" /> Garantía
                7 días
              </div>
              <div className="flex items-center" data-id="element-153">📥 Descarga inmediata</div>
              <div className="flex items-center" data-id="element-154">🖨️ Listo para imprimir</div>
              <div className="flex items-center" data-id="element-155">
                <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-156" /> Pago
                seguro
              </div>
              <div className="flex items-center" data-id="element-157">
                <CreditCard className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-158" />{' '}
                Mercado Pago
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Social Proof Bar */}
      <div className="mt-12 border-y border-brand-pink/20 bg-white/50 py-4" data-id="element-159">
        {/* Mobile: wrapped grid */}
        <div className="md:hidden flex flex-wrap justify-center gap-x-5 gap-y-2 px-4 text-sm pl-[16px] pr-[16px]" data-id="element-160">
          <div className="flex items-center" data-id="element-161">
            <span className="font-bold text-brand-rose mr-1.5" data-id="element-162">+200</span>
            terapeutas
          </div>
          <div className="flex items-center" data-id="element-163">
            <span className="font-bold text-brand-rose mr-1.5" data-id="element-164">1</span>
            Tomo listo
          </div>
          <div className="flex items-center" data-id="element-165">
            <span className="font-bold text-brand-rose mr-1.5" data-id="element-166">3</span> Bonus
          </div>
          <div className="flex items-center" data-id="element-167">
            <Star className="w-3.5 h-3.5 text-brand-rose fill-brand-rose mr-1" data-id="element-168" />
            4.9/5
          </div>
        </div>

        {/* Desktop: horizontal row with dots */}
        <div className="hidden md:flex flex-row items-center gap-6 justify-center whitespace-nowrap px-4 text-sm" data-id="element-169">
          <div className="flex items-center" data-id="element-170">
            <span className="font-bold text-brand-rose mr-2" data-id="element-171">+200</span>
            terapeutas organizados
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-rose/30 shrink-0" data-id="element-172"></div>
          <div className="flex items-center" data-id="element-173">Tomo listo</div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-rose/30 shrink-0" data-id="element-174"></div>
          <div className="flex items-center" data-id="element-175">
            <span className="font-bold text-brand-rose mr-2" data-id="element-176">3</span> Bonus
            incluidos
          </div>
          <div className="w-1.5 h-1.5 rounded-full bg-brand-rose/30 shrink-0" data-id="element-177"></div>
          <div className="flex items-center" data-id="element-178">
            <Star className="w-4 h-4 text-brand-rose fill-brand-rose mr-1" data-id="element-179" />
            4.9/5 calificación
          </div>
        </div>
      </div>
    </div>;
};